export default {
  // doneMaterials: { 0: [] },
  doneMaterials: [],
  currentLevel: 0
};
